module.exports = __webpack_public_path__ + "img/sala.19c0ee86.png";